import { extendTheme } from "@chakra-ui/react";
const theme = extendTheme({
  fonts: {
    heading: `'Quicksand', sans-serif`,
    body: `'Quicksand', sans-serif`,
  },
});

export default theme;
